import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "content"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasContentTarget || !this.hasTriggerTarget) return

    if (this.triggerTarget.checked) {
      this.contentTarget.style.display = "block"
    } else {
      this.contentTarget.style.display = "none"
      const nestedCheckbox = this.contentTarget.querySelector('input[type="checkbox"]')
      if (nestedCheckbox) {
        nestedCheckbox.checked = false
      }
    }
  }
}
